import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i-26727908__a)" }, [
      _createElementVNode("path", {
        fill: "#878FA2",
        d: "M7.875 3.208a1.17 1.17 0 0 0 1.167-1.166A1.17 1.17 0 0 0 7.875.875a1.17 1.17 0 0 0-1.167 1.167 1.17 1.17 0 0 0 1.167 1.166ZM5.717 5.192l-1.494 7.53a.58.58 0 0 0 .572.695h.047a.586.586 0 0 0 .571-.455l.945-4.212 1.225 1.167v2.916c0 .321.263.584.584.584.32 0 .583-.263.583-.584v-3.29c0-.32-.128-.624-.362-.845l-.863-.823.35-1.75a4.27 4.27 0 0 0 2.543 1.406.586.586 0 0 0 .665-.583.582.582 0 0 0-.495-.572c-.887-.146-1.622-.671-2.013-1.36l-.583-.933c-.327-.519-.98-.729-1.546-.49l-2.234.945a1.173 1.173 0 0 0-.712 1.08V7c0 .32.263.583.583.583.321 0 .584-.262.584-.583V5.6l1.05-.408Z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-26727908__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h14v14H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "DirectionsWalk"}) } }